module.exports = __webpack_public_path__ + "static/media/link-tool.4fccfbf7.svg";